// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  settleId: __t.u64().primaryKey().name("settle_id"),
  creator: __t.identity(),
  grossSov: __t.i64().name("gross_sov"),
  platformCutSov: __t.i64().name("platform_cut_sov"),
  netSov: __t.i64().name("net_sov"),
  forDay: __t.string().name("for_day"),
  at: __t.timestamp(),
});
